import React from 'react'
import MessageUtils from '../../util/MessageUtils'
import './Button.css'

const ButtonUI = ({ label, messageList, labelKey, onClick, dataId, disabled, transparent, type }) =>
  <button
    className={`w_button ${transparent ? 'transparent' : ''} ${disabled ? 'disabled' : ''}`}
    type={type === 'button' ? 'button' : 'submit'}
    onClick={onClick}
    data-id={dataId}
    disabled={disabled}
  >
    {
      label &&
      <React.Fragment>{label}</React.Fragment>
    }
    {
      labelKey &&
      <React.Fragment>
        {MessageUtils.getMessageValue(messageList, labelKey)}
      </React.Fragment>
    }
  </button>

export default ButtonUI
